import Perfis from "@/config/perfis";

export default class Can{

    static can_any_role(el, binding, vNode) {

        let roles = Can.trata_valores_bind_can(binding);
        if (process.env.NODE_ENV === 'production' && roles.includes(Perfis.HOMOLOG)) {
            vNode.elm.style.display = "none";
            return;
        }
        if (vNode.context.$store.state.permissions.includes(Perfis.ADMIN)) {
            return;
        }
        if (!binding.value) {
            return;
        }
        if(!roles || roles.length === 0) {
            return;
        }
        for(let i = 0; i < roles.length; i++) {
            if(vNode.context.$store.state.permissions.includes(roles[i])){
                return;
            }
        }
        vNode.elm.style.display = "none";
    }

    static can_all_roles(el, binding, vNode) {
        if (vNode.context.$store.state.permissions.includes(Perfis.ADMIN)) {
            return;
        }

        if (!binding.value) {
            return;
        }

        let roles = Can.trata_valores_bind_can(binding);

        if (!roles || roles.length === 0) {
            return;
        }

        for (let i = 0; i < roles.length; i++) {
            if (!vNode.context.$store.state.permissions.includes(roles[i])) {
                vNode.elm.style.display = "none";
            }
        }
    }

    static can_user_id_in(el, binding, vNode) {
        if (vNode.context.$store.state.permissions.includes(Perfis.ADMIN)) {
            return;
        }

        if (!binding.value) {
            return;
        }

        let users = Can.trata_valores_bind_can(binding);

        if(!users || users.length === 0) {
            vNode.elm.style.display = "none";
        }

        if(!users.includes(vNode.context.$store.state.userId)){
            vNode.elm.style.display = "none";
        }
    }

    static can_user_authenticated(el, binding, vNode) {
        if(!vNode.context.$store.state.authenticated) {
            vNode.elm.style.display = "none";
        }
    }

    static can_user_unauthenticated(el, binding, vNode) {
        if(vNode.context.$store.state.authenticated) {
            vNode.elm.style.display = "none";
        }
    }

    static trata_valores_bind_can(binding) {
        let values = binding.value;

        if(typeof values === 'string') {
            values = values.split(',')
        }

        if(!Array.isArray(values)) {
            console.log("Erro de definição no can-role")
            return []
        }

        return values
    }
}